module.exports = JBrowseExports["@jbrowse/core/BaseFeatureWidget/BaseFeatureDetail"]["@jbrowse/core/BaseFeatureWidget/BaseFeatureDetail/BaseCard"];